var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationsSidebar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#264D6D",
    strokeWidth: 1.5,
    d: "M7.34 2.99c-2.683.69-4.665 3.124-4.665 6.023v4.145c0 .382-.31.691-.69.691-.763 0-1.382.62-1.382 1.382v1.037c0 .19.153.345.346.345h15.89c.19 0 .346-.157.346-.345v-1.037c0-.763-.622-1.382-1.383-1.382-.381 0-.69-.307-.69-.691V9.013c0-2.898-1.981-5.332-4.664-6.022v-.714c0-.86-.696-1.555-1.554-1.555-.857 0-1.555.696-1.555 1.555v.713zm-.865 14.314h4.837c0 1.335-1.083 2.418-2.418 2.418-1.336 0-2.419-1.083-2.419-2.418z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationsSidebar);
export default __webpack_public_path__ + "static/media/icon-notifications-sidebar.f06703a2bdc297d00634f13fd909644f.svg";
export { ForwardRef as ReactComponent };